/**
 * Converts a number to either a round number if its a whole number, or fixed to specified precision if not
 *
 * i.e.
 * - formatIfNotRound(10.1234) returns 10.12
 * - formatIfNotRound(10.00) returns 10
 * - formatIfNotRound(10) returns 10
 */
export const roundOrToFixed = (num: number, precision?: number): number => {
  if (num % 1 !== 0) {
    return parseFloat(num.toFixed(precision || 2));
  }

  return num;
};
